import React from "react";
import Footer from "../components/Footer";
import HeroSection from "../components/HeroSection";
import FeaturesSection from "../components/FeaturesSection";
import CareersSection from "../components/CareersSection";
import ContactSection from "../components/ContactSection";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-brand-dark text-white">
      <HeroSection />
      <FeaturesSection />
      <CareersSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
